import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="flex h-dvh items-center justify-center bg-nb-bg">
      <div className="text-center">
        <h1 className="text-3xl font-semibold">404</h1>
        <p className="mt-2 text-sm text-nb-text-2">{t("ui.notFound.message")}</p>
        <Link to="/dashboard" className="btn-primary mt-4 inline-block">
          {t("ui.notFound.backToDashboard")}
        </Link>
      </div>
    </main>
  );
}